import { hasNoValue } from '@util';
import { DataGridColumn } from 'ngrx-data-grid';
import * as R from 'ramda';

const containsColumnByField = (sourceColumn: DataGridColumn, columns: DataGridColumn[]) =>
  R.any(column => R.eqProps('field', sourceColumn, column), columns);

const findColumnPositionByField = (sourceColumn: DataGridColumn, columns: DataGridColumn[]) =>
  R.findIndex(column => R.eqProps('field', column, sourceColumn), columns);

const getHeaderName = R.prop('headerName');

const findColumnsContainedInDefaultColumns = (defaultColumns: DataGridColumn[], columns: DataGridColumn[]) =>
  R.filter(column => containsColumnByField(column, defaultColumns), columns) as DataGridColumn[];

const findDefaultColumnsWithNoHeaderNotContainedInColumns = (defaultColumns: DataGridColumn[], columns: DataGridColumn[]) =>
  R.filter(column => hasNoValue(getHeaderName(column)) && !containsColumnByField(column, columns), defaultColumns);

// Used for calculation of the columns for grid that does not store grid configuration.
// Decides if the column is spare/missing based on default columns and inserts/removes it properly.
export const updateGridColumnsByDefaultColumns = (defaultColumns: DataGridColumn[], columns: DataGridColumn[]) => {
  if (hasNoValue(columns)) {
    return defaultColumns;
  }
  const filteredColumns = findColumnsContainedInDefaultColumns(defaultColumns, columns);
  return insertMissingNoHeaderDefaultColumnsInColumns(defaultColumns, filteredColumns);
};

const insertMissingNoHeaderDefaultColumnsInColumns = (defaultColumns: DataGridColumn[], columns: DataGridColumn[]) => {
  const filteredColumns = findDefaultColumnsWithNoHeaderNotContainedInColumns(defaultColumns, columns);
  let newColumns = [...columns];
  R.forEach(column => {
    const position = findColumnPositionByField(column as DataGridColumn, defaultColumns);
    newColumns = R.insert(position, column, newColumns) as DataGridColumn[];
  } )(filteredColumns);
  return newColumns;
};


